import { render } from "./fail.vue?vue&type=template&id=435f1002&scoped=true"
const script = {}

import "./fail.vue?vue&type=style&index=0&id=435f1002&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435f1002"]])

export default __exports__